import { render } from "./EnrichmentManagement.vue?vue&type=template&id=4b675208&scoped=true"
import script from "./EnrichmentManagement.vue?vue&type=script&lang=js"
export * from "./EnrichmentManagement.vue?vue&type=script&lang=js"

import "./EnrichmentManagement.vue?vue&type=style&index=0&id=4b675208&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b675208"]])

export default __exports__